import { render, staticRenderFns } from "./BaseDrawerOrBottomSheet.vue?vue&type=template&id=26e60a5e"
import script from "./BaseDrawerOrBottomSheet.vue?vue&type=script&lang=ts"
export * from "./BaseDrawerOrBottomSheet.vue?vue&type=script&lang=ts"
import style0 from "./BaseDrawerOrBottomSheet.vue?vue&type=style&index=0&id=26e60a5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports